export default __webpack_public_path__ + "static/media/extraLinens.7ae3e70c.jpg";